import { useEffect, useState } from "react";

import { screens } from "@vericus/cadmus-ui";

import { useMediaQuery } from "@mantine/hooks";

/**
 * Hook to manage the open state of the sidebar alonside screen resolution.
 * @returns A tuple with the open state and a function to toggle it.
 */
export function useSidebarOpenState(): [boolean, () => void] {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const isMinTablet = useMediaQuery(`(min-width: ${screens.tablet})`);
  useEffect(() => {
    if (isMinTablet !== undefined) {
      setIsOpen((open) => {
        if (isMinTablet && !open) {
          return true;
        } else if (!isMinTablet && open) {
          return false;
        }
        return open;
      });
    }
  }, [isMinTablet, setIsOpen]);

  return [isOpen, () => setIsOpen(!isOpen)];
}
